export class Employee {
  empNo: number;
  first_name: string;
  last_name: string;

 
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/Employee.ts